import { mcpUrl } from '@/utils/environment'

/** Setup options on the public "Connect your AI agent" page (/ai). Labels live in i18n under `aiConnect`. */

export type AiAgentId = 'claude' | 'codex' | 'antigravity' | 'mistral'
export type ClaudeRegisterOption = 'account' | 'cli' | 'windows' | 'mac'
export type DesktopOs = 'windows' | 'mac' | 'linux'
export type ScriptOs = 'unix' | 'windows'

export interface AiIcon {
  src: string
  /** Monochrome dark artwork that needs inverting in the dark theme. */
  invertInDark?: boolean
}

const icon = (name: string, invertInDark = false): AiIcon => ({ src: `/images/ai/${name}.svg`, invertInDark })

export const AI_ICONS = {
  claude: icon('claude'),
  codex: icon('codex'),
  antigravity: icon('antigravity'),
  mistral: icon('mistral'),
  terminal: icon('terminal', true),
  windows: icon('windows'),
  apple: icon('apple', true),
  linux: icon('linux'),
}

export const AI_AGENTS: { id: AiAgentId; icons: AiIcon[] }[] = [
  { id: 'claude', icons: [AI_ICONS.claude] },
  { id: 'codex', icons: [AI_ICONS.codex] },
  { id: 'antigravity', icons: [AI_ICONS.antigravity] },
  { id: 'mistral', icons: [AI_ICONS.mistral] },
]

export const CLAUDE_REGISTER_OPTIONS: { id: ClaudeRegisterOption; icons: AiIcon[] }[] = [
  { id: 'account', icons: [AI_ICONS.claude] },
  { id: 'cli', icons: [AI_ICONS.terminal] },
  { id: 'windows', icons: [AI_ICONS.windows] },
  { id: 'mac', icons: [AI_ICONS.apple] },
]

export const DESKTOP_OS_OPTIONS: { id: DesktopOs; icons: AiIcon[] }[] = [
  { id: 'windows', icons: [AI_ICONS.windows] },
  { id: 'mac', icons: [AI_ICONS.apple] },
  { id: 'linux', icons: [AI_ICONS.linux] },
]

export const SCRIPT_OS_OPTIONS: { id: ScriptOs; icons: AiIcon[] }[] = [
  { id: 'unix', icons: [AI_ICONS.apple, AI_ICONS.linux] },
  { id: 'windows', icons: [AI_ICONS.windows] },
]

export const AI_LINKS = {
  claudePersonalConnector: 'https://claude.ai/customize/connectors?modal=add-custom-connector',
  claudeTeamConnector: 'https://claude.ai/admin-settings/connectors?modal=add-custom-connector',
  claudeDownload: 'https://claude.com/download',
  claudeCliInstall: 'https://code.claude.com/docs/en/quickstart#step-1-install-claude-code',
  claudeConnectors: 'https://claude.ai/customize/connectors',
  codexCliInstall: 'https://developers.openai.com/codex/quickstart?setup=cli',
  codexAppInstall: 'https://developers.openai.com/codex/quickstart?setup=app',
  antigravityDownload: 'https://antigravity.google/download',
}

export const AI_COMMANDS = {
  mcpUrl,
  claudeCli: `claude mcp add --transport http adnuntius ${mcpUrl}`,
  codexAdd: `codex mcp add adnuntius --url ${mcpUrl}`,
  antigravityWindows: `$j='{"mcpServers":{"adnuntius":{"serverUrl":"${mcpUrl}"}}}'; foreach($d in 'antigravity','config'){ $p="$env:USERPROFILE\\.gemini\\$d\\mcp_config.json"; New-Item -ItemType Directory -Force -Path (Split-Path $p) | Out-Null; [System.IO.File]::WriteAllText($p,$j) }`,
  antigravityUnix: `python3 -c "import os,json;d={'mcpServers':{'adnuntius':{'serverUrl':'${mcpUrl}'}}};[(os.makedirs(os.path.dirname(p),exist_ok=True) or json.dump(d,open(p,'w'),indent=2)) for p in [os.path.expanduser('~/.gemini/antigravity/mcp_config.json'),os.path.expanduser('~/.gemini/config/mcp_config.json')]]"`,
  mistralUnix: 'curl -fsSL https://raw.githubusercontent.com/Adnuntius/documentation/master/mcp/mistral-vibe/install.sh | bash',
  mistralWindows: 'iwr https://raw.githubusercontent.com/Adnuntius/documentation/master/mcp/mistral-vibe/install.ps1 -UseBasicParsing | iex',
}
